import { FilterConfig } from './filter-config';
import { type OptionsMap } from 'src/types';


export type SelectValue = { code: string; label: string } | null;

export class SelectFilterConfig extends FilterConfig {
  get defaultValue(): null {
    return null;
  }

  isEmpty(value: SelectValue): boolean {
    return value === null || value === undefined;
  }

  toLabel(filterData: SelectValue): string | null {
    if (!filterData) return null;
    return typeof filterData === 'object' ? filterData.label : String(filterData);
  }

  toQuery(filterData: SelectValue): string | null {
    if (!filterData) return null;
    return typeof filterData === 'object' ? filterData.code : filterData;
  }

  toUrl(filterData: SelectValue): string | null {
    if (!filterData) return null;
    return typeof filterData === 'object' ? filterData.code : String(filterData);
  }

  fromUrl(paramValue: string, options: OptionsMap): SelectValue {
    return { code: paramValue, label: options[paramValue] ?? paramValue };
  }
}
